export class NavigationDependencies {
	claimId: string = "0";
	claimantId: string = "0";
	lobId: string = "0";
  claimNumber: string = "0";
	newClaimant: string = "0";
}
